/**
 * @file index.tsx
 *
 * @fileoverview Renders blog banner image.
 */

import { Image as ImageType } from '~/jobiqo/types/types';
import Image from '~/jobiqo/components/Image';
import styles from './blogBanner.module.scss';

interface BlogBannerProps {
  /**
   * The banner image.
   */
  image: ImageType;
}

export function BlogBanner({
  image: { alt, title, url, caption },
}: BlogBannerProps) {
  return (
    <div className={styles.banner}>
      <span className={styles.bannerOverlay} />
      <Image
        width={null}
        height={null}
        src={url}
        alt={alt ?? ''}
        {...(title && { title })}
        priority={true}
      />
      {caption && <span className={styles.bannerCaption}>{caption}</span>}
    </div>
  );
}
export default BlogBanner;
